import {
  Card as UiCard,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle
} from '@Pages/pageRuntime/components/ui/Card';
import { cn } from '@Pages/pageRuntime/lib/utils';
import type React from 'react';

type CardProps = {
  /**
   * Optional card heading.
   */
  title?: React.ReactNode;

  /**
   * Supporting text below the title.
   */
  description?: React.ReactNode;

  /**
   * Main card content.
   */
  children?: React.ReactNode;

  /**
   * Footer area for actions or metadata.
   */
  footer?: React.ReactNode;

  className?: string;
  contentClassName?: string;
};

/**
 * A theme-aware container for grouping related content and actions. Use cards to create
 * visual hierarchy without overusing borders on every small item.
 *
 * @example
 * <Sdk.Components.Card title="Profile" description="Current student details">
 *   <p>Student details</p>
 * </Sdk.Components.Card>
 */
export function Card({
  title,
  description,
  children,
  footer,
  className,
  contentClassName
}: CardProps) {
  return (
    <UiCard className={className}>
      {title || description ? (
        <CardHeader>
          {title ? <CardTitle>{title}</CardTitle> : null}
          {description ? <CardDescription>{description}</CardDescription> : null}
        </CardHeader>
      ) : null}
      {children ? (
        <CardContent className={cn(!title && !description && 'pt-6', contentClassName)}>
          {children}
        </CardContent>
      ) : null}
      {footer ? <CardFooter>{footer}</CardFooter> : null}
    </UiCard>
  );
}
